import React from 'react';
import ReactAvatar from 'react-avatar';
import styles from './avatar.module.scss';

import {
  map,
  reduce,
  omitBy,
  sortBy,
  split,
  join,
  reverse,
  take,
  head,
  size,
  indexOf,
  upperCase,
  floor,
  isEmpty,
} from 'lodash';
// import { fullName } from 'redux/modules/talent';

export const MAX_INITIALS = 2;

export const COLORS = [
  'F7412C',
  'EC1562',
  '9D1DB2',
  '3F4DB8',
  '1294F6',
  '00BCD7',
  '48B14C',
  'CDDE20',
  'FEC200',
];

export function avatarOptions(entity, type) {
  if (!entity) return {};
  switch (type) {
    case 'client':
      return {
        src: entity.logo && entity.logo,
        name: entity.title || entity.name, // Some places use title, others use name
      };
    case 'talent':
      return {
        name: entity?.full_name,
        src: entity?.avatar,
      };

    case 'contact':
      return {
        src: entity?.avatar && entity?.avatar,
        name: entity?.first_name,
        email: entity?.email,
      };
    case 'user':
      return {
        src: entity?.avatar && entity?.avatar,
        // name: fullName(entity),
        name: entity?.label,
        email: entity?.email,
      };
    case 'project':
      return omitBy(
        {
          name: entity?.title,
          color: entity?.colour?.hex || entity?.color,
        },
        isEmpty,
      );
    default:
      return {
        name: entity?.name,
        email: entity?.email,
      };
  }
}




/*
export const Avatar = (props) => {
  const { name, color, initials, src, className, fontSize = '16px', ...rest } = props;
  console.log('Avatar received props:', { name, color, initials, src });


  // Normalize color handling (moved outside component)
  function normalizeColor(inputColor) {
    if (!inputColor) return null;
    // Remove # if present
    return inputColor.startsWith('#') ? inputColor.substring(1) : inputColor;
  }

  // Use the direct color prop or fall back to initials-based color
  const finalColor = '#' + (normalizeColor(color) || colorFromInitials(initialsFromName(name)));

  return (
    <ReactAvatar
      name={name}
      src={src}
      color={finalColor}
      round
      className={styles[className]}
      {...rest}
      style={{ fontSize }}
    />
  );
};
*/
export function ensureProjectColor(project, fallbackColor = 'FEC200') {
  if (!project) return project;
  
  // Original logic: prefer hex color from project object, fallback to colour_id mapping, then fallbackColor
  if (project.colour && project.colour.hex) {
    return { ...project, colour: { hex: project.colour.hex } };
  }
  if (typeof project.colour === 'string') {
    return { ...project, colour: { hex: project.colour } };
  }
  if (project.colour_hex) {
    return { ...project, colour: { hex: project.colour_hex } };
  }
  if (project.color) {
    return { ...project, colour: { hex: project.color } };
  }
  // Map colour_id to hex color if present
  const COLOUR_ID_MAP = {
    1: 'F7412C', // red
    2: 'EC1562', // pink
    3: '9D1DB2', // purple
    4: '3F4DB8', // indigo
    5: '00BCD7', // cyan
    6: '1294F6', // blue
    7: '48B14C', // green
    8: 'CDDE20', // lime
    9: 'FEC200', // yellow
  };
  if (project.colour_id && COLOUR_ID_MAP[project.colour_id]) {
    return { ...project, colour: { hex: COLOUR_ID_MAP[project.colour_id] } };
  }
  // Final fallback: use fallbackColor argument
  return { ...project, colour: { hex: fallbackColor } };
}

// Helper function to ensure a client has a color
export function ensureClientColor(client, defaultColor = '272e41') {
  if (!client) return client;
  
  const clonedClient = { ...client };
  
  if (!clonedClient.colour || !clonedClient.colour.hex) {
    clonedClient.colour = { hex: defaultColor };
  }
  
  return clonedClient;
}

function initialsFromName(name) {
  const candidates = split(name, ' ');
  const selected = take(reverse(sortBy(candidates, size)), MAX_INITIALS);
  const reordered = sortBy(selected, (w) => indexOf(candidates, w));
  const initials = map(reordered, head);
  return map(initials, upperCase);
}

function colorFromInitials(initials) {
  const max = MAX_INITIALS * 'Z'.charCodeAt();
  const score = reduce(initials, (sum, item) => sum + item.charCodeAt() || 0, 0);
  const percentage = max > 0 ? (score * 100) / max : 0;
  const index = floor((percentage * size(COLORS)) / 100);
  return COLORS[index];
}

// Normalize color handling (moved outside component)
function normalizeColor(inputColor) {
  if (!inputColor) return null;
  // Remove # if present
  return inputColor.startsWith('#') ? inputColor.substring(1) : inputColor;
}

export const Avatar = (props) => {
  const { name, color, initials, src, className, fontSize, ...rest } = props;
  console.log('Avatar received props:', { name, color, initials, src });

  // Use the direct color prop or fall back to initials-based color
  const finalColor = '#' + (normalizeColor(color) || colorFromInitials(initialsFromName(name)));

  // Create style object with fontSize if provided
  const style = fontSize ? { fontSize } : undefined;

  return (
    <ReactAvatar
      name={name}
      src={src}
      color={finalColor}
      round
      className={styles[className]}
      {...rest}
      style={style}
    />
  );
};
